import *as React from 'react'

import {postier} from './Postier'
import {AppContext} from "../../../Context/AppContext"

import "./style.scss"
import { getDate, getDay } from './GetDate'
import { ReactElement, useContext, useState } from 'react'
import { InsertHour } from './InsertHour'

export function Horaires(): ReactElement {

    const {token,site,client,setLoading, date, setDate, setErrors, role} = useContext(AppContext)
    const [horaires, setHoraireData] = useState([])
    const [pagina, setPagina] = useState<string>("main")

    const setHoraires = (arg)=>{
        setLoading(false)
        setHoraireData(arg)
    }

    React.useEffect(() => {
        setLoading(true)
        // console.log({datetype: typeof date})
        postier.getHoraires(token,client,site,setHoraires,date, setErrors)
        // console.log(site)
    }, [date, site, pagina])

    const insertHour = (page)=>{
        setPagina(page)
    }

    const days = horaires[0]?horaires.map(day=>{
        
        const opening = day.Opening
        const middayClose = day.MiddayClosing
        const middayOpening = day.MidddayOpening
        const closing = day.Closing
        
        const jour = getDay(day)


        return <div className="day" key={Math.random()}>
            <div>
                <h1>{jour}</h1>
            </div>

            <div className="date">
                {getDate(date, day.WeekDay)}
            </div>

            <div className="hour">{opening}</div>
            <div className="hour">{middayClose}</div>
            <div className="hour">{middayOpening}</div>
            <div className="hour">{closing}</div>
    </div>}):<Nodata setHoraires={setHoraires} />

    return (
        <div className="ouverture">
            <div className="datepicker">
                <label> date : </label>
                <input type="date" value={date} onChange={e=>setDate(e.target.value)}/>
                {role !== 'Viewer' && <button onClick={()=>insertHour("modif")} >Modifier les horaires</button>}

            </div>
            <div className="semaine">
                {pagina=="main"?<HeadderHour days={days} /> :<InsertHour setPagina={insertHour}/>}
            </div>
        </div>
        
    )
}

const HeadderHour = ({days})=>{
    return<> <div className="day headder" >
    <h1>horaires</h1>
    <div className="hour">date</div>
    <div className="hour">ouverture</div>
    <div className="hour">début pause</div>
    <div className="hour">fin pause</div>
    <div className="hour">fermeture</div>
</div>
{days}
</>
}

const Nodata = ({setHoraires}) =>{
    const {token,site,client,date, setErrors} = useContext(AppContext)

    const createHour = ()=>{
        postier.createHoraire(token,client,site,setHoraires,date, setErrors)
    }

    return <div className="nodata">
        <p></p>Chargement des données ... (si cela prend trop de temps, rechargez la page)
        <button onClick={createHour} >Recharger</button>
    </div>
}